import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from '../QuestionContainer';
import {
  QuestionInputContainer,
  QuestionInputHalfHeight,
  QuestionSubHeading,
} from '../TextQuestion/TextQuestion.styles';

const OTHER_COUNTRY_VALUE = 'Other';

interface Props {
  organisation: string;
  countries: Array<{ name: string }>;
  selectedCountryName: string;
  onCountrySelected(countryName: string): void;
  backLink: string;
  nextLink: string;
  percentage: number;
}

export const CountryQuestion: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const otherLabel = t('public.Country.other');
  const options = [...props.countries, { name: otherLabel }];

  const [selected, setSelected] = React.useState<{ name: string } | null>(
    options.find((c) => c.name === props.selectedCountryName) ?? null,
  );

  return (
    <QuestionContainer
      organisation={props.organisation}
      backLink={props.backLink}
      nextLink={props.nextLink}
      i18nHeader="public.Country.header"
      percentage={props.percentage}
      submitAnswer={() => {
        props.onCountrySelected(
          selected?.name === otherLabel
            ? OTHER_COUNTRY_VALUE
            : (selected?.name ?? ''),
        );
      }}
    >
      <QuestionInputContainer>
        <QuestionInputHalfHeight>
          <QuestionSubHeading>
            {t('public.Country.description')}
          </QuestionSubHeading>
          <Autocomplete
            data-testid="country-autocomplete"
            options={options}
            getOptionLabel={(option) => option.name}
            value={selected}
            onChange={(_event, newValue) => {
              setSelected(newValue);
            }}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            noOptionsText={t('public.Country.noOptions')}
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid="country-input"
                variant="standard"
                placeholder={t('public.Country.placeholder')}
              />
            )}
          />
        </QuestionInputHalfHeight>
      </QuestionInputContainer>
    </QuestionContainer>
  );
};

export default CountryQuestion;
